<template>
  <div>
    <h3 class="h-title">提交文件-拟存储文件</h3> 
    <el-form class="e-form f-b" ref="cForm" :model="cForm" label-width="100px"  label-position="left" :rules="setpFormRules5">
        <el-form-item class="w-70" label="拟存储文件" prop="planSaveFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'planSaveFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'planSaveFile')" 
            :on-error="handleError"
            :file-list="cForm.planSaveFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
        <div class="el-form-item__error" v-show="isFile">
          请上传
        </div>
      </el-form-item> 
      <p class="tips">上传的文件中需包含如下列表中的材料:</p>
      <el-table
        :data="fileData"
        border
        style="width: 1000px">
        <el-table-column
          type="index"
          width="50" />
        <el-table-column
          prop="name"
          label="材料名称"
          width="240">
        </el-table-column>
        <el-table-column
          prop="type"
          label="材料形式"
          width="220">
        </el-table-column>
        <el-table-column
          prop="desc"
          label="备注">
        </el-table-column>
      </el-table>
    </el-form>
    <div class="cenrer">			
      <el-button class="s-but" type="orange" @click.native="prev">上一步</el-button>
      <el-button class="s-but" type="orange" @click="cSubmitForm('0')" :loading="butLoading">保 存</el-button>
      <el-button class="s-but" type="orange" @click="cSubmitForm('1')" :loading="butLoading">提 交</el-button>
    </div>
  </div>
</template>

<script>
import baseUrl from '@/api/baseUrl.js'
export default {
  name: "step5",
  props: ["active"],
  data() {
    return {
      headers: {
        Authorization: "Bearer " + sessionStorage.getItem("token")
      },
      action: '',
      butLoading: false,
      cForm: {},
      setpFormRules5: {
        planSaveFile: [
            { type: 'array', required: true, message: '请上传', trigger: 'change' }
        ]
      },
      isFile: false,
      fileData: [{
          name: '拟存储的数据',
          type: '原数据或数据样例',
          desc: '主要包括数据类型、数据项字段名称、数据格式名称、数据记录条数等'
        },
        {
          name: '数据来源说明文件及相关资料',
          type: '原件或复印件加盖业务申请人公章',
          desc: '说明数据来源属于个人数据、单位数据或公共数据。其中涉及个人数据的，应当提交依法获取的证明；涉及单位数据的，需说明内部数据采集和外部数据采集情况；涉及公共数据的，应当提供依法获取的证明。'
        },{
          name: '数据资产形成或交易过程中的成本凭证',
          type: '原件或复印件加盖业务申请人公章',
          desc: '数据资产形成或交易过程中发生的前期费用、直接成本和间接成本统计，以下为各阶段成本列示，提供相关合同及付款凭证'
        },
        {
          name: '数据资产可研分析报告及相关资料',
          type: '原件或复印件加盖公章',
          desc: '（包含与数据资产应用场景相关的宏观经济和行业前景）'
        },{
          name: '数据应用场景说明文件',
          type: '原件或复印件加盖业务申请人公章',
          desc: '说明数据适用的条件、范围、对象，清楚反映数据应用所能解决的主要问题'
        },
        {
          name: '法律意见书及相关资料',
          type: '原件或复印件加盖律师事务所公章',
          desc: '如在服务要素中选择“合规评估”为“有”，则本文件为存储必要件'
        },{
          name: '数据资产可研分析报告及相关资料',
          type: '原件或复印件加盖公章',
          desc: '（包含与数据资产应用场景相关的宏观经济和行业前景）'
        },
        {
          name: '数据质量评价报告及相关资料',
          type: '原件或复印件加盖出具机构公章',
          desc: '如在服务要素中选择“质量评估”为“有”，则本文件为存储必要件'
        },{
          name: '数据资产评估报告及相关资料',
          type: '原件或复印件加盖评估机构公章',
          desc: '如在服务要素中选择“价值评估”为“有”，则本文件为存储必要件'
        },
        {
          name: '数据资产审计报告及相关资料',
          type: '原件或复印件加盖会计师事务所公章',
          desc: ' '
        },{
          name: '数据资产应用的相关合同及收入凭证',
          type: '原件或复印件加盖业务申请人公章',
          desc: ' '
        },
        {
          name: '数据价值凭证',
          type: '原件或复印件加盖业务申请人公章',
          desc: ' '
        },
         ],

    }
  },
  watch: {
      active(newVal) {
        if(newVal == 5) {
          window.scrollTo(0,0);
          this.action = `${baseUrl.iaccUrl}/iacc-contract-platform/common/uploadFile`;
          // this.action = `http://172.30.15.232:9097/common/uploadFile`;
          this.cForm = JSON.parse(sessionStorage.setpForm);
          this.cForm.planSaveFile = JSON.parse(this.cForm.planSaveFile || '[]');
        } 
      }
    },
     mounted(){
      this.action = `${baseUrl.iaccUrl}/iacc-contract-platform/common/uploadFile`;
      
    },
  methods: {  
    prev() {
      this.cForm.planSaveFile = JSON.stringify(this.cForm.planSaveFile||[]);
      sessionStorage.setpForm = JSON.stringify(this.cForm);
      this.$emit('prev')
    },
    cSubmitForm(status){

      

      if(status == '0'){
        this.butLoading = true;
        this.cForm.status = status
        this.cForm.planSaveFile = JSON.stringify(this.cForm.planSaveFile||[]);

        this.$api.api.saveData(JSON.stringify(this.cForm)).then(response => {
          this.butLoading = false;
          if(response.code == 200){
            sessionStorage.removeItem("setpForm")
            this.$message.success("保存成功");
            this.$router.push(`/dataContract?sceneType=01`);
          }else {
            this.$message.error(response.msg);
          }      
        });
      }else {
 

        if (this.cForm.planSaveFile.length > 0) {

          this.butLoading = true;
          this.cForm.status = status
          this.cForm.planSaveFile = JSON.stringify(this.cForm.planSaveFile||[]);

          let arr = []
          if(JSON.parse(sessionStorage.getItem('setpForm')).completeConformanceAssess == '有'){
            arr.push('完成合规评估')
          }
          if(JSON.parse(sessionStorage.getItem('setpForm')).completeQualityAssess == '有'){
            arr.push('完成质量评估')
          }
          if(JSON.parse(sessionStorage.getItem('setpForm')).completeValueAssess == '有'){
            arr.push('完成价值评估')
          }



          if(arr.length > 0){
            let arrStr = arr.join('、')
            this.$confirm(`您已在服务要素页面勾选“${arrStr}”，请确认拟存储文件中包含此文件`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$api.api.saveData(JSON.stringify(this.cForm)).then(response => {
                this.butLoading = false;
                if(response.code == 200){
                  sessionStorage.removeItem("setpForm")
                  this.$message.success("提交成功");
                  this.$router.push(`/dataContract?sceneType=01`);
                }else {
                  this.$message.error(response.msg);
                }      
              });
            }).catch(() => {
                this.butLoading = false;        
            });
          }else{
            this.$api.api.saveData(JSON.stringify(this.cForm)).then(response => {
                this.butLoading = false;
                if(response.code == 200){
                  sessionStorage.removeItem("setpForm")
                  this.$message.success("提交成功");
                  this.$router.push(`/dataContract?sceneType=01`);
                }else {
                  this.$message.error(response.msg);
                }      
              });
          }
           






         

          
        
        }else {
          this.isFile = true
        }
      } 
    },
    handleError(err, file, fileList){
        this.$message.error(file.name + "文件上传失败");
      },
      beforeUpload(file) { 	
        const isLt2M = file.size / 1024 / 1024 <= 80     //这里做文件大小限制
        
        if(!isLt2M) {
          this.$message.error('上传文件大小不能超过 80MB！');
        }
        return isLt2M
      },
      upload(response, file, list, name){
          if(response.code == 200){
            this.$set(this.cForm, name, [{
              name: response.name,
              url: response.url
            }])
            this.isFile = false
          }else{
            this.$set(this.cForm, name,[])
            this.isFile = true
            if(response.msg){
              this.$message.error(response.msg);
            }else {
              this.$message.error(file.name + "文件上传失败");
            }							
          }            
      },
      handleRemove(file, fileList, name) {
        this.$set(this.cForm, name, [])

      },
  }
}
</script>
<style type="text/css">
  .tips{font-size: 12px;  color: #999;   margin-top: 100px;}
</style>
